function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 9a.8.8 0 01.8-.8h6a.8.8 0 010 1.6H9a.8.8 0 01-.8-.8zM8.2 12a.8.8 0 01.8-.8h6a.8.8 0 010 1.6H9a.8.8 0 01-.8-.8zM9 14.2a.8.8 0 000 1.6h3a.8.8 0 000-1.6H9z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.404 3.404A1.55 1.55 0 014.5 2.95h15a1.55 1.55 0 011.55 1.55v10.19a1.55 1.55 0 01-.454 1.095l-4.81 4.811a1.551 1.551 0 01-1.097.454H4.5a1.55 1.55 0 01-1.55-1.55v-15c0-.411.163-.805.454-1.096zM4.55 4.55v14.9h9.65V15a.8.8 0 01.8-.8h4.45V4.55H4.55zM18.32 15.8H15.8v2.519l2.52-2.52z",
    fill: props.fill
  }));
}

export default SvgNote;